module.exports = __webpack_public_path__ + "Flag-222.af822e5761cd0b2b0b5b985165bc3875.svg";